export const tr = {
    autotargeting: 'Otomatik hedefleme',
    campaign: 'Kampanya ',
    clicks: 'Tıklamalar',
    'clicks-forecast': 'Tıklama tahmini',
    cost: 'Harcama, {currency}',
    'cost-forecast': 'Harcama tahmini, {currency}',
    name: 'Grup'
};
